/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditoraddsection3Inputs */

const en_menueditoraddsection3 = /** @type {(inputs: Menueditoraddsection3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a section`)
};

const de_menueditoraddsection3 = /** @type {(inputs: Menueditoraddsection3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereich hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add a section" |
*
* @param {Menueditoraddsection3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditoraddsection3 = /** @type {((inputs?: Menueditoraddsection3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditoraddsection3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditoraddsection3(inputs)
	return de_menueditoraddsection3(inputs)
});
export { menueditoraddsection3 as "menuEditorAddSection" }